(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["v2-complementary-products"] && !Shopify.designMode) return;
  try {
    class ComplimentaryProducts extends HTMLElement {
    constructor() {
      super();

      this.itemsWrapper = this.querySelector('.complementary-products__list');
    }

    connectedCallback() {
      this.#fetchProducts();
      this.#initSwiper();
    }

    #initSwiper() {
      const swiperEl = this.querySelector('.swiper');

      if (typeof Swiper !== 'undefined') {
        new Swiper(swiperEl, {
          slidesPerView: 1,
          loop: true,
          draggable: true,
          spaceBetween: 20,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        });
      } else {
        requestAnimationFrame(this.#initSwiper.bind(this));
      }
    }

    #fetchProducts() {
      return fetch(
        window.Shopify.routes.root +
          `recommendations/products.json?product_id=${this.dataset.productId}&intent=complementary&limit=5`
      )
        .then((response) => response.json())
        .then((data) => {
          this.#renderProducts(data.products);
        })
        .catch((error) => {
          console.error('Error fetching complementary products:', error);
        });
    }

    #fetchFirstInsitu(product) {
      return fetch(product.url)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const firstInsitu = doc.querySelector('script[type="application/json"]#insitu-data');
          if (!firstInsitu) {
            return null;
          }
          return JSON.parse(firstInsitu.textContent);
        });
    }

    #stripHtml(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html || '', 'text/html');
      return doc.body.textContent || '';
    }

    #renderProducts(products) {
      if (!products || products.length === 0) {
        this.style.display = 'none';
        return;
      }

      let priceConfig = {};
      if (window.Shopify.shop.includes('usa')) {
        priceConfig = {
          tax: 1,
          countryCode: 'US',
          currency: 'USD',
        };
      } else {
        priceConfig = {
          tax: 1.2,
          countryCode: 'GB',
          currency: 'GBP',
        };
      }

      Promise.all(
        products.map(async (product) => {
          const firstInsitu = await this.#fetchFirstInsitu(product);
          const plainDescription = this.#stripHtml(product.description).trim();
          const truncatedDescription =
            plainDescription.length > 150
              ? `${plainDescription.split(' ').splice(0, 20).join(' ')}...`
              : plainDescription;

          let image = '';
          if (firstInsitu?.firstInsitu) {
            image = `https://${window.Shopify.cdnHost}/shop/${firstInsitu.firstInsitu}?width=400&height=400`;
          } else {
            image = product.featured_image ? `${product.featured_image}?width=400&height=400` : '';
          }

          return `
              <a href="${product.url}" class="complementary-products__item swiper-slide" role="listitem">
                <h3 class="copy-sm-medium">You may also like</h3>

                <div class="complementary-products__image${
                  firstInsitu?.firstInsitu ? ' complementary-products__image--insitu' : ''
                }"><img src="${image}" alt="${product.title}" width="400" height="400"/></div>
                <div class="complementary-products__meta">

                  <div class="complementary-products__meta-top">
                    <h3 class="copy-sm-medium">You may also like</h3>
                    <h4 class="header-sm-bold">${product.title}</h4>
                    <p class="copy-sm-light">${truncatedDescription}</p>
                  </div>

                  <div class="complementary-products__meta-bottom">
                    <h5 class="copy-sm-medium price">From ${AM.formatCurrency(
                      product.price,
                      priceConfig.tax,
                      priceConfig.countryCode,
                      priceConfig.currency
                    )}</h5>
                    <div class="complementary-products__buying">
                      <div class="copy-sm-medium">Shop now</div>
                    </div>
                  </div>
                </div>
              </a>
            `;
        })
      ).then((htmlArray) => {
        this.itemsWrapper.innerHTML = htmlArray.join('');

        if (htmlArray.length > 1) {
          this.classList.add('complementary-products--has-multiple');
        }
      });
    }
  }

  customElements.define('complementary-products', ComplimentaryProducts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-product-description"] && !Shopify.designMode) return;
  try {
    const description = document.querySelector('.main-product__purchasing__description__content');
  const previewEl = description.querySelector('[data-product-description-preview]');
  const fullEl = description.querySelector('[data-product-description-full]');
  const toggleEl = description.querySelector('[data-product-description-toggle]');

  if (!previewEl || !fullEl || !toggleEl) {
    return;
  }

  previewEl.hidden = false;
  fullEl.hidden = true;
  toggleEl.hidden = false;

  toggleEl.addEventListener('click', function () {
    const isExpanded = toggleEl.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      toggleEl.setAttribute('aria-expanded', 'false');
      toggleEl.textContent = 'Read more';
      previewEl.hidden = false;
      fullEl.hidden = true;
      return;
    }

    toggleEl.setAttribute('aria-expanded', 'true');
    toggleEl.textContent = 'Read less';
    previewEl.hidden = true;
    fullEl.hidden = false;
  });
  } catch(e) { console.error(e); }
})();

})();
